// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_4nRh1","tag":"tag_JyRAA","text":"text_aTqHb","off":"off_ZWTsV"};